import { useEffect, useState } from 'react';

/** Volgt of de donkere modus actief is (de klasse `dark` op <html>, gezet door useSettings). */
export function useDonker() {
  const lees = () => document.documentElement.classList.contains('dark');
  const [donker, setDonker] = useState(lees);
  useEffect(() => {
    const o = new MutationObserver(() => setDonker(lees()));
    o.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });
    setDonker(lees());
    return () => o.disconnect();
  }, []);
  return donker;
}
